import { callApiWithAuthorization } from "../CallApi";

export async function getAttributeTemplates(organizationId, options = {}) {
    const params = new URLSearchParams();
    if (options.skip != null) params.set("skip", options.skip);
    if (options.take != null) params.set("take", options.take);
    if (options.group != null) params.set("group", options.group);
    const query = params.toString();
    const url = "/api/v0/organization/" + organizationId + "/attributeTemplates" + (query ? "?" + query : "");
    const request = await callApiWithAuthorization(url);
    const response = await request.json();
    return response;
}

export async function getAttributeTemplate(attributeTemplateId) {
    let request = await callApiWithAuthorization("/api/v0/attributeTemplate/" + attributeTemplateId);
    let response = await request.json();
    return response;
}

export async function createAttributeTemplate(organizationId, properties) {
    let request = await callApiWithAuthorization("/api/v0/organization/" + organizationId + "/attributeTemplate", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(properties)
    });
    let response = await request.json();
    return response;
}

export async function updateAttributeTemplate(attributeTemplateId, properties) {
    let request = await callApiWithAuthorization("/api/v0/attributeTemplate/" + attributeTemplateId, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(properties)
    });
    let response = await request.json();
    return response;
}

export async function deleteAttributeTemplate(attributeTemplateId) {
    let request = await callApiWithAuthorization("/api/v0/attributeTemplate/" + attributeTemplateId, {
        method: "DELETE",
        headers: {
            "Content-Type": "application/json",
        }
    });
    let response = await request.json();
    return response;
}

export async function bulkDeleteAttributeTemplates(attributeTemplateIds) {
    let request = await callApiWithAuthorization("/api/v0/attributeTemplates/bulkDelete", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ attributeTemplateIds })
    });
    let response = await request.json();
    return response;
}